import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { Card, Col, Container, Row } from 'reactstrap';
import { TranslationsKeys } from '../../../locales/translations';
import { StudentWarningsRiskLevel } from '../types';

export type StudentWarningsSummaryDetailsBlockProps = {
  name: string;
  riskLevel: StudentWarningsRiskLevel | null;
  warnings?: number;
  date?: string;
};

const BG_COLORS: Record<StudentWarningsRiskLevel, string> = {
  [StudentWarningsRiskLevel.Low]: '#CEF0DA',
  [StudentWarningsRiskLevel.Medium]: '#FFEFC6',
  [StudentWarningsRiskLevel.High]: '#FCEEED',
};

const StudentWarningsSummaryDetailsBlock = ({
  name,
  riskLevel,
  warnings,
  date,
}: StudentWarningsSummaryDetailsBlockProps) => {
  const { t } = useTranslation(TranslationsKeys.STUDENT_ALERTS_DETAILS);

  return (
    <Card
      className="border border-primary"
      style={{
        backgroundColor: riskLevel ? BG_COLORS[riskLevel] : 'white',
      }}
    >
      <Container fluid>
        <Row className="pb-4 gutters-filters py-4">
          <Col className="mb-3" xs={12}>
            <span className="fs-20 text-uppercase text-primary mb-0 fw-700">
              {name}
            </span>
          </Col>
          <Col xs={warnings !== undefined ? 6 : 12}>
            <div className="w-100 d-block">
              <span className="w-100 d-block fs-12 text-uppercase mb-0">
                {date
                  ? `${t('detailBlock.riskLevel')} ${dayjs(date).format(
                      'DD/MM/YYYY',
                    )}`
                  : t('detailBlock.riskLevel')}
              </span>
              <span className="w-100 d-block fs-12 text-uppercase text-primary mb-0 fw-700">
                {t(`riskLevels.${riskLevel ?? 'NULL'}`)}
              </span>
            </div>
          </Col>
          {warnings !== undefined && (
            <Col xs={6}>
              <div>
                <span className="w-100 d-block fs-12 text-uppercase mb-0">
                  {t('detailBlock.warnings')}
                </span>
                <span className="w-100 d-block fs-12 text-uppercase text-primary mb-0 fw-700">
                  {t('detailBlock.warningsCount', { count: warnings })}
                </span>
              </div>
            </Col>
          )}
        </Row>
      </Container>
    </Card>
  );
};

export default StudentWarningsSummaryDetailsBlock;
